/* eslint-disable indent */
import React from "react";
import EditableTag3x3 from "./components/EditableTag3x3";
import EditableTag6x4 from "./components/EditableTag6x4";
import EditableTag6x8 from "./components/EditableTag6x8";
import EditableTag10x10 from "./components/EditableTag10x10";
import EditableTag10x7 from "./components/EditableTag10x7";
import EditableTag9x3 from "./components/EditableTag9x3";
import EditableTag12x5 from "./components/EditableTag12x5";
import EditableTag16x5 from "./components/EditableTag16x5";

const EditableTag = ({ initialData, size = "6x4", doubleTag = false }) => {
	// Rotear para o componente específico baseado no tamanho
	// Cada componente tem seu próprio layout baseado no PDF original correspondente
	const sizeComponents = {
		"3x3": EditableTag3x3,
		"6x4": EditableTag6x4,
		"6x8": EditableTag6x8,
		"10x10": EditableTag10x10,
		"10x7": EditableTag10x7,
		"9x3": EditableTag9x3,
		"12x5": EditableTag12x5,
		"16x5": EditableTag16x5
	};

	const SelectedComponent = sizeComponents[size] || EditableTag6x4;

	return <SelectedComponent initialData={initialData} doubleTag={doubleTag} />;
};

export default EditableTag;
